import { type FC, Fragment, useEffect, useRef } from "react";
import { Table } from "@root/shared/components/Table/legacy/Table";
import { Th } from "@root/shared/components/Table/legacy/Th";
import { Td } from "@root/shared/components/Table/legacy/Td";
import { Tr } from "@root/shared/components/Table/legacy/Tr";
import { useReadMoreButtonHeight } from "@root/shared/components/ReadMoreButton/useReadMoreButtonHeight";
import * as styles from "./styles.css";

export type ActivityHistoriesProps = Record<string, Record<string, string[]>>;

type Props = {
  activityHistories: ActivityHistoriesProps[];
};

export const ActivityHistoriesTable: FC<Props> = ({ activityHistories }) => {
  const setContainerHeight = useReadMoreButtonHeight();
  const elementRefs = useRef<(HTMLDivElement | null)[]>([]);

  const activityHistoryTitleText = (historyKey: string) => {
    switch (historyKey) {
      case "JobPremiumScout":
        return "プレミアムスカウトを送信しました";
      case "AutoJobPremiumScout":
        return "自動送信プレミアムスカウトを送信しました";
      case "JobScout":
        return "スカウトを送信しました";
      case "AutoJobScout":
        return "自動送信スカウトを送信しました";
      case "JobEntry":
        return "応募がありました";
      default:
        return "";
    }
  };

  useEffect(() => {
    if (
      elementRefs.current[0] &&
      elementRefs.current[1] &&
      elementRefs.current[2] &&
      setContainerHeight
    ) {
      const totalRefHeight =
        elementRefs.current[0].clientHeight +
        elementRefs.current[1].clientHeight +
        elementRefs.current[2].clientHeight;
      // ボタンを表示する高さは３つ目の要素の高さ
      setContainerHeight(totalRefHeight);
    }
  }, [setContainerHeight]);

  return (
    <>
      {activityHistories.map((history, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={`${Object.keys(history)[0]}_${index}`}>
          {Object.keys(history).map((historyKey) => {
            return (
              <div
                className={styles.activityHistoryContainer}
                key={historyKey}
                ref={(el) => (elementRefs.current[index] = el)}
              >
                <p className={styles.activityHistoryTitle}>
                  {activityHistoryTitleText(historyKey)}
                </p>
                <Table key={historyKey} className={styles.activityHistoryTable}>
                  {Object.keys(history[historyKey]).map((historyObjectKey) => (
                    <Tr key={historyObjectKey}>
                      <Th>{historyObjectKey}</Th>
                      <Td>
                        {history[historyKey][historyObjectKey].map((historyItem, itemIndex) => (
                          // eslint-disable-next-line react/no-array-index-key
                          <Fragment key={`${historyItem}_${itemIndex}`}>
                            {historyItem}
                            <br />
                          </Fragment>
                        ))}
                      </Td>
                    </Tr>
                  ))}
                </Table>
              </div>
            );
          })}
        </Fragment>
      ))}
    </>
  );
};
